<script>
    export let context; context;
    import Blogs from '../blogs_definitions';
    import Image from '../components/Image.svelte';
    import { fade } from 'svelte/transition';
    import { onMount } from 'svelte';
	import router from 'page';

    function tagColor(tag) {
        switch (tag) {
            case 'New':
                return 'is-info';
            case 'Featured':
                return 'is-danger';
            default:
                return 'is-warning';
        }
    }
    let load_limit = 0;
    let prev_load_limit = 0;
    let load_more;
    onMount(() => {
        load_limit = 8;
    });

    function scrollHandle() {
        if (load_more && load_more.getBoundingClientRect().top < window.innerHeight) {
            load_limit += 8;
        }
    }

    function updatePrevLoadLimit() {
        prev_load_limit = load_limit;
    }

    if (context.querystring.startsWith('date=')) {
        const date = context.querystring.split('&')[0];
        const date_value = date.split('=')[1];
        const blog = Blogs.find(b => b.old_id === date_value);
        router(`/blog/${blog.id}`);
    }
</script>

<svelte:window on:scroll={scrollHandle}/>

<div>
    <section class="section">
        <h1 class="title">
            Blogs
        </h1>
        <h3 class="subtitle">
            We have many blog posts that you can read on our website.
        </h3>
    </section>
    <section class="section">
        <div class="columns is-multiline">
            {#each Blogs as {id, title, abstract, image, author, date, tags}, i}
                {#if i < load_limit}
                    <div class="column is-one-quarter" in:fade={{ duration: 300, delay: 100 * (i - prev_load_limit) }} on:introend={updatePrevLoadLimit}>
                        <div class="card">
                            <div class="card-image">
                                <figure class="image">
                                    {#if image}<Image src={image} alt="{title}"/>{/if}
                                </figure>
                            </div>
                            <div class="card-content">
                                <div class="tags">
                                    {#each tags as tag}
                                        <span class="tag {tagColor(tag)}">{tag}</span>
                                    {/each}
                                </div>
                                    <p class="title">{title}</p>
                                    <p class="subtitle">
                                        <time>{date}</time>
                                        <br/>
                                        {#if author}By {author}{/if}
                                    </p>
                                <div class="content">
                                    {abstract}
                                </div>
                            </div>
                            <div class="card-footer">
                                <a class="card-footer-item" href="/blog/{id}">Read</a>
                            </div>
                        </div>
                    </div>
                {/if}
            {/each}
            {#if load_limit < Blogs.length}
                <div class="load-more-container container">
                    <button class="button is-info" bind:this={load_more}>Load More</button>
                </div>
            {/if}
        </div>
    </section>
</div>

<style>
    .card {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .card-content {
        margin-top: auto;
    }

    .load-more-container {
        text-align: center;
    }

    .load-more-container > button {
        margin: auto;
    }
</style>